/* RESPONSIBLE TEAM: team-frontend-tech */
import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';

export default class CaptureRenderStart extends Helper {
  @service frontendStatsService;

  compute(_params, { subject, ...options }) {
    this.frontendStatsService.startInteractionTime(subject, options);
  }
}
